import React from 'react';
import Box from '@mui/system/Box';
import Typography from '@mui/material/Typography';
import { IconButton, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { ChildrenAccordionProps } from '../../types';

const ChildrenAccordion: React.FC<ChildrenAccordionProps> = ({ fname, lname, dob, gender, genders, isNew, onDelete }) => {
    const genderOption = genders.find((option) => option.toLowerCase() === gender.toLowerCase());

    function formatLastName(lastName: string) {
        const words = lastName.trim().split(' ');
        return words[words.length - 1];
    }

    return (
        <Box component="section" sx={{ p: 1, border: '1px solid #ccc' }} className="mb-2 box">
            <Typography><b>{fname} {formatLastName(lname)}</b></Typography>
            <Typography>{dob}</Typography>
            <Typography>{genderOption}</Typography>

            {isNew && (
                <Tooltip title="Delete" onClick={onDelete}>
                    <IconButton>
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            )}
        </Box>
    );
};

export default ChildrenAccordion;
